import { Grid } from "@mui/material"
import { useEffect, useState } from "react"
import {
    getStartingMonthIndexInMonths,
    months,
    monthsAsPropertyNames,
    SZJAMentességHatárértékFt,
    SZJASzázalék,
    SZOCHOMinimálbér,
    SZOCHOGarantáltBérminimum,
    SZOCHOSzázalék,
    TBMinimálBér,
    TBGarantáltBérminimum,
    TBSzázalék,
} from "../globals/constants"
import { MONTH } from "../globals/enums"
import { CalculatorObj } from "../types/CalculatorObj"
import { MonthlyWagesObj } from "../types/MonthlyWagesObj"
import NumberInput from "./input/NumberInput"

type Props = {
    monthlyWagesObj: MonthlyWagesObj
    isMonthly: boolean
    setCalculatorObj: React.Dispatch<React.SetStateAction<CalculatorObj>>
    calculatorObj: CalculatorObj
    setMonthlyWagesObj: React.Dispatch<React.SetStateAction<MonthlyWagesObj>>
    show: boolean
}

var inputMinimumWageType: string;	//MINIMUMWAGE=szakkepesites NEM igenylo munka / GUARANTEEDMINIMUMWAGE=szakkepesitest IGENYLO
var inputStartDate: string;
var inputExpectedIncome: number;
var inputCostRatioPercent: number;			//40/80/90
var inputIPAKeyPercent: number;				//1/2
var inputLegalRelationshipType: string;		// Főfoglalkozású / Mellékfoglalkozású / Kieg.tevékenységű (nyugdíjas)


/*
Source code translations

feudatory 					= adóköteles
taking 						= bevétel
income 		                = jövedelem
tax-free 					= adómentes
minimum wage 				= minimálbér
guaranteed minimum wage 	= bérminimum
cost ratio                  = költséghányad
rolled up                   = gönygyölt
legal relationship			= jogviszony

 */

var haviBevételek: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviJövedelmek: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviBevételekGöngyölt: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviJövedelmekGöngyölt: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviKöltségarányok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviSZJAAlapok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviSZJA: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviTB: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviAdóköteles: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviAdókötelesGöngyölt: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviTBAlap: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviSZOCHOAdatok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviSZOCHOAlapAdatok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviIPAAdatok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviÖsszesKöltségAdatok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
var haviNettoAdatok: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

//TODO: Remove eval and reach resultObj's properties dynamically...
export const getArrayAsObject = (arrName: string): MonthlyWagesObj => {
    let resultObj = {} as MonthlyWagesObj;
    let arr: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    let thisMonth;
    // eslint-disable-next-line no-eval
    eval(`arr = ${arrName};`)
    for (let i = 0; i < 12; i++) {
        thisMonth = monthsAsPropertyNames[i];
        // eslint-disable-next-line no-eval
        eval(`resultObj.${thisMonth} = ${arr[i]};`);
    }
    return resultObj
}

export const getLastIPAAdat = (): number => {
    return haviIPAAdatok[11];
}

const getMonthFromDateStringYYYYMMOrHungarianMonthAsText = (startDate: string): number => {
    startDate = startDate.replaceAll(" ", "-");
    let result = startDate.split("-", -1)[1];
    result = result.replace(/^0{0,1}/gm, "");
    let resultNumber = parseInt(result, 10);
    if (isNaN(resultNumber)) {
        let monthBeginnings = ["Ja", "F", "Már", "Á", "Máj", "Jún", "Júl", "A", "Sz", "O", "N", "D"];
        for (let i = 0; i < monthBeginnings.length; i++) {
            if (result.indexOf(monthBeginnings[i]) === 0) {
                return i + 1;
            }
        }
        return 1;
    }
    return resultNumber;
}

const calculateAllRolledUpIncomeValues = (): void => {
    haviJövedelmekGöngyölt[0] = haviJövedelmek[0]
    for (let i = 1; i < 12; i++) {
        haviJövedelmekGöngyölt[i] = haviJövedelmek[i] + haviJövedelmekGöngyölt[i - 1]
    }
}

const calculateHaviGöngyöltBevételek = (): void => {
    haviBevételekGöngyölt[0] = haviBevételek[0]
    for (let i = 1; i < 12; i++) {
        haviBevételekGöngyölt[i] = haviBevételek[i] + haviBevételekGöngyölt[i - 1]
    }
}

const haviÁtlagjövedelmekKiszámítása = (): void => {

    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);
    let totalMonths = 12 - startingMonth + 1;
    let incomeMonthly = inputExpectedIncome / totalMonths;

    for (let i = 0; i < 12; i++) {
        haviJövedelmekGöngyölt[i] = 0;
    }
    for (let i = 0; i < 12; i++) {
        if (i < 12 - totalMonths) {
            haviBevételek[i] = 0;
            haviJövedelmek[i] = 0;
            haviKöltségarányok[i] = 0;
        } else {
            haviBevételek[i] = incomeMonthly;
            haviJövedelmek[i] = incomeMonthly * (1 - inputCostRatioPercent / 100);
            haviKöltségarányok[i] = haviBevételek[i] - haviJövedelmek[i];
        }
    }

    calculateAllRolledUpIncomeValues()
    calculateHaviGöngyöltBevételek()
}

const haviEgyediJövedelmekKiszámítása = (monthlyWagesObj: any): void => {

    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);
    let totalMonths = 12 - startingMonth + 1;
    let thisMonthIncome;

    for (let i = 0; i < 12; i++) {
        if (i < 12 - totalMonths) {
            haviBevételek[i] = 0;
            haviJövedelmek[i] = 0;
            haviKöltségarányok[i] = 0;
            haviJövedelmekGöngyölt[i] = 0;
        } else {
            switch (i) {
                case 0:
                    thisMonthIncome = monthlyWagesObj.january;
                    break;
                case 1:
                    thisMonthIncome = monthlyWagesObj.february;
                    break;
                case 2:
                    thisMonthIncome = monthlyWagesObj.march;
                    break;
                case 3:
                    thisMonthIncome = monthlyWagesObj.april;
                    break;
                case 4:
                    thisMonthIncome = monthlyWagesObj.may;
                    break;
                case 5:
                    thisMonthIncome = monthlyWagesObj.june;
                    break;
                case 6:
                    thisMonthIncome = monthlyWagesObj.july;
                    break;
                case 7:
                    thisMonthIncome = monthlyWagesObj.august;
                    break;
                case 8:
                    thisMonthIncome = monthlyWagesObj.september;
                    break;
                case 9:
                    thisMonthIncome = monthlyWagesObj.october;
                    break;
                case 10:
                    thisMonthIncome = monthlyWagesObj.november;
                    break;
                case 11:
                    thisMonthIncome = monthlyWagesObj.december;
                    break;
                default:
                    break;
            }

            haviBevételek[i] = (thisMonthIncome);
            haviJövedelmek[i] = thisMonthIncome * (1 - inputCostRatioPercent / 100);
            haviKöltségarányok[i] = (haviBevételek[i] - haviJövedelmek[i]);

        }
    }

    calculateAllRolledUpIncomeValues()
    calculateHaviGöngyöltBevételek()
}

const isQ1 = (monthNo: number): boolean => {
    return ++monthNo < 4;
}

const isQ2 = (monthNo: number): boolean => {
    return !isQ1(monthNo) && ++monthNo < 7;
}

const isQ3 = (monthNo: number): boolean => {
    return !isQ1(monthNo) && !isQ2(monthNo) && ++monthNo < 10;
}

const isQ4 = (monthNo: number): boolean => {
    return !isQ1(monthNo) && !isQ2(monthNo) && !isQ3(monthNo) && monthNo < 12 && monthNo >= 0;
}




// Removed switchWagesTo2023 and switchWagesTo2023_12 functions


const haviSZJAlapokKiszámítása = (): void => {
    let upperPart, SZJABase;
    let összJövedelem = 0;
    // 2023 logic removed: use current minimálBér and garantáltBérminimum values
    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate) - 1;
    for (let i = startingMonth; i < 12; i++) {
        // 2023 logic removed
        összJövedelem += haviJövedelmek[i];
        if (összJövedelem < SZJAMentességHatárértékFt) {
            haviSZJAAlapok[i] = 0;
        } else {
            upperPart = összJövedelem - SZJAMentességHatárértékFt;
            SZJABase = Math.min(upperPart, haviJövedelmek[i]);
            haviSZJAAlapok[i] = SZJABase;
            let SZJA = SZJABase * SZJASzázalék / 100;
            haviSZJA[i] = SZJA;
        }
    }
}





const haviTBAlapokKiszámítása_2 = (): void => {

    // 2023 logic removed: use current minimálBér and garantáltBérminimum values
    let baseForCurrentMonth;
    let tmpSum = 0;
    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);

    let adóköteles_Q1 = haviAdókötelesGöngyölt[2];
    let adóköteles_Q2 = haviAdókötelesGöngyölt[5];
    let adóköteles_Q3 = haviAdókötelesGöngyölt[8];
    let adóköteles_Q4 = haviAdókötelesGöngyölt[11];

    let minimumWageToUse = 0;
    startingMonth--;
    for (let i = startingMonth; i < 12; i += 1) {
        // 2023 logic removed
        minimumWageToUse = inputMinimumWageType === "MINIMUMWAGE" ? SZOCHOMinimálbér : SZOCHOGarantáltBérminimum;
        if (isQ1(i)) {
            tmpSum = adóköteles_Q1 / 3;
            tmpSum = startingMonth === 1 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 2 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ2(i)) {
            tmpSum = (adóköteles_Q2 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2])) / 3;
            tmpSum = startingMonth === 4 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 5 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ3(i)) {
            tmpSum = (adóköteles_Q3 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2] + haviTBAlap[3] + haviTBAlap[4] + haviTBAlap[5])) / 3;
            tmpSum = startingMonth === 7 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 8 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ4(i)) {
            tmpSum = (adóköteles_Q4 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2] + haviTBAlap[3] + haviTBAlap[4] + haviTBAlap[5] + haviTBAlap[6] + haviTBAlap[7] + haviTBAlap[8])) / 3;
            tmpSum = startingMonth === 10 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 11 ? tmpSum * 3 / 1 : tmpSum;
        }
        baseForCurrentMonth = tmpSum < minimumWageToUse ? minimumWageToUse : tmpSum;
        baseForCurrentMonth = inputLegalRelationshipType === "Mellékfoglalkozású" ? tmpSum : baseForCurrentMonth;
        baseForCurrentMonth = inputLegalRelationshipType.indexOf("yugdíj") !== -1 ? 0 : baseForCurrentMonth;
        haviTBAlap[i] = baseForCurrentMonth;
    }
    for (let i = 0; i < 12; i++) {
        // Minimum szochó alap: minimálbér vagy garantált bérminimum
        if (!inputLegalRelationshipType.toLowerCase().includes("nyugdíj")) {
            const minSzochoAlap = inputMinimumWageType === "MINIMUMWAGE" ? SZOCHOMinimálbér : SZOCHOGarantáltBérminimum;
            const szochoAlap = Math.max(haviTBAlap[i], minSzochoAlap);
            haviSZOCHOAdatok[i] = szochoAlap * (SZOCHOSzázalék / 100);
        }
    }
}



// Mellékfoglalkozású átalányadózó TB és SZOCHO alap számítása a példában leírt szabály szerint




// TB és SZOCHO: gördülő negyedéves szabály szerint
const calculateSideJobQuarterlyBaseRolling = (
    adokotesesJovedelem: number[],
    previousQuarterBases: number[],
    quarterStart: number,
    quarterEnd: number,
    insuredMonths: number
) => {
    // Halmozott SZJA-köteles jövedelem az aktuális negyedév végéig
    let sumIncome = 0;
    for (let i = 0; i <= quarterEnd; i++) {
        sumIncome += adokotesesJovedelem[i];
    }
    // Korábbi negyedévekben már járulékalapként figyelembe vett összeg
    let sumPrevBases = 0;
    for (let i = 0; i < quarterStart; i++) {
        sumPrevBases += previousQuarterBases[i];
    }
    return insuredMonths > 0 ? (sumIncome - sumPrevBases) / insuredMonths : 0;
};

// SZOCHO: csak a mentes határ felett, a korábbi logika szerint
const calculateSideJobQuarterlyBaseSZOCHO = (
    adokotesesJovedelem: number[],
    previousQuarterBases: number[],
    quarterStart: number,
    quarterEnd: number,
    insuredMonths: number,
    szjaMentesHatár: number
) => {
    let cumSum = 0;
    let overLimitMonth = -1;
    for (let i = 0; i <= quarterEnd; i++) {
        cumSum += adokotesesJovedelem[i];
        if (cumSum > szjaMentesHatár && overLimitMonth === -1) {
            overLimitMonth = i;
        }
    }
    if (overLimitMonth === -1 || overLimitMonth > quarterEnd) {
        return 0;
    }
    if (overLimitMonth >= quarterStart && overLimitMonth <= quarterEnd) {
        let sumPrev = 0;
        for (let i = 0; i < overLimitMonth; i++) {
            sumPrev += adokotesesJovedelem[i];
        }
        let aboveLimit = cumSum - szjaMentesHatár;
        let rest = 0;
        for (let i = overLimitMonth + 1; i <= quarterEnd; i++) {
            rest += adokotesesJovedelem[i];
        }
        let base = aboveLimit + rest;
        return insuredMonths > 0 ? base / insuredMonths : 0;
    }
    let sumIncome = 0;
    for (let i = 0; i <= quarterEnd; i++) {
        sumIncome += adokotesesJovedelem[i];
    }
    let sumPrevBases = 0;
    for (let i = 0; i < quarterStart; i++) {
        sumPrevBases += previousQuarterBases[i];
    }
    return insuredMonths > 0 ? (sumIncome - sumPrevBases) / insuredMonths : 0;
};

const haviTBAlapokKiszámítása = (): void => {
    // Mellékfoglalkozású speciális negyedéves TB/SZOCHO alap
    // ...existing code...

    // A végén nullázzuk TB és SZOCHO-t, ha nyugdíjas jogviszony van, hogy minden felülírást felülírjon
    if (inputLegalRelationshipType.toLowerCase().includes("nyugdíj")) {
        for (let i = 0; i < 12; i++) {
            haviTBAlap[i] = 0;
            haviTB[i] = 0;
            haviSZOCHOAlapAdatok[i] = 0;
            haviSZOCHOAdatok[i] = 0;
        }
        return; // Ne fusson tovább, ne írja felül semmi
    }
    if (inputLegalRelationshipType === "Mellékfoglalkozású") {
        // Negyedévek: [0-2], [3-5], [6-8], [9-11]
        const quarters = [
            { start: 0, end: 2 },
            { start: 3, end: 5 },
            { start: 6, end: 8 },
            { start: 9, end: 11 }
        ];
        // TB alap mindig számolódik a negyedéves szabály szerint, mentes határ nélkül
        let previousQuarterBases = Array(12).fill(0);
        for (let q = 0; q < quarters.length; q++) {
            const { start, end } = quarters[q];
            const insuredMonths = end - start + 1;
            const base = calculateSideJobQuarterlyBaseRolling(
                haviAdóköteles,
                haviTBAlap,
                start,
                end,
                insuredMonths
            );
            for (let m = start; m <= end; m++) {
                haviTBAlap[m] = base;
                previousQuarterBases[m] = base;
            }
        }
        for (let i = 0; i < 12; i++) {
            haviTB[i] = haviTBAlap[i] * (TBSzázalék / 100);
        }
        // SZOCHO alap csak akkor, ha az éves jövedelem > minimálbér * 6
        const yearlyIncome = haviJövedelmek.reduce((sum, val) => sum + val, 0);
        const minWage6x = 6 * (inputMinimumWageType === "MINIMUMWAGE" ? SZOCHOMinimálbér : SZOCHOGarantáltBérminimum);
        if (yearlyIncome > minWage6x) {
            let previousSzochoBases = Array(12).fill(0);
            for (let q = 0; q < quarters.length; q++) {
                const { start, end } = quarters[q];
                const insuredMonths = end - start + 1;
                const base = calculateSideJobQuarterlyBaseRolling(
                    haviAdóköteles,
                    haviSZOCHOAlapAdatok,
                    start,
                    end,
                    insuredMonths
                );
                for (let m = start; m <= end; m++) {
                    haviSZOCHOAlapAdatok[m] = base;
                    previousSzochoBases[m] = base;
                }
            }
            for (let i = 0; i < 12; i++) {
                if (!inputLegalRelationshipType.toLowerCase().includes("nyugdíj")) {
                    haviSZOCHOAdatok[i] = haviSZOCHOAlapAdatok[i] * (SZOCHOSzázalék / 100);
                }
            }
        } else {
            for (let i = 0; i < 12; i++) {
                haviSZOCHOAlapAdatok[i] = 0;
                haviSZOCHOAdatok[i] = 0;
            }
        }
        return;
    }
    // Egyéb jogviszonyok: eredeti logika
    let baseForCurrentMonth;
    let tmpSum = 0;
    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);

    let adóköteles_Q1 = haviAdókötelesGöngyölt[2];
    let adóköteles_Q2 = haviAdókötelesGöngyölt[5];
    let adóköteles_Q3 = haviAdókötelesGöngyölt[8];
    let adóköteles_Q4 = haviAdókötelesGöngyölt[11];

    let minimumWageToUse = 0;
    startingMonth--;
    for (let i = startingMonth; i < 12; i += 1) {
        minimumWageToUse = inputMinimumWageType === "MINIMUMWAGE" ? TBMinimálBér : TBGarantáltBérminimum;
        if (isQ1(i)) {
            tmpSum = adóköteles_Q1 / 3;
            tmpSum = startingMonth === 1 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 2 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ2(i)) {
            tmpSum = (adóköteles_Q2 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2])) / 3;
            tmpSum = startingMonth === 4 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 5 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ3(i)) {
            tmpSum = (adóköteles_Q3 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2] + haviTBAlap[3] + haviTBAlap[4] + haviTBAlap[5])) / 3;
            tmpSum = startingMonth === 7 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 8 ? tmpSum * 3 / 1 : tmpSum;
        }
        if (isQ4(i)) {
            tmpSum = (adóköteles_Q4 - (haviTBAlap[0] + haviTBAlap[1] + haviTBAlap[2] + haviTBAlap[3] + haviTBAlap[4] + haviTBAlap[5] + haviTBAlap[6] + haviTBAlap[7] + haviTBAlap[8])) / 3;
            tmpSum = startingMonth === 10 ? tmpSum * 3 / 2 : tmpSum;
            tmpSum = startingMonth === 11 ? tmpSum * 3 / 1 : tmpSum;
        }
        // Minimum TB alap: minimálbér vagy garantált bérminimum
        baseForCurrentMonth = Math.max(tmpSum, minimumWageToUse);
        baseForCurrentMonth = inputLegalRelationshipType.indexOf("yugdíj") !== -1 ? 0 : baseForCurrentMonth;
        haviTBAlap[i] = baseForCurrentMonth;
    }
    for (let i = 0; i < 12; i++) {
        haviTB[i] = haviTBAlap[i] * (TBSzázalék / 100);
    }
}

const haviAdókötelesAdatokKiszámítása = (): void => {
    let SZJAMentességFt;
    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);
    // 2023 logic removed: use current minimálBér and garantáltBérminimum values
    for (let i = startingMonth - 1, jövedelemSumma = 0; i < 12; i++) {
        // 2023 logic removed
        jövedelemSumma += haviJövedelmek[i];

        if (jövedelemSumma < SZJAMentességHatárértékFt) {
            haviAdóköteles[i] = 0;
        } else {
            SZJAMentességFt = jövedelemSumma - SZJAMentességHatárértékFt;
            if (SZJAMentességFt > haviJövedelmek[i]) {
                SZJAMentességFt = haviJövedelmek[i];
            }
            haviAdóköteles[i] = SZJAMentességFt;
        }
        if (i > 0) {
            haviAdókötelesGöngyölt[i] = haviAdókötelesGöngyölt[i - 1] + haviAdóköteles[i];
        } else {
            haviAdókötelesGöngyölt[i] = haviAdóköteles[i];
        }
    }
}



const haviIPAAdatokKiszámítása = (): void => {
    // If expected revenue exceeds 25M, do not calculate HIPA
    if (inputExpectedIncome > 25000000) {
        for (let i = 0; i < 12; i++) {
            haviIPAAdatok[i] = 0;
        }
        return;
    }
    for (let i = 0; i < 12; i++) {
        let currentGöngyöltBevétel = haviBevételekGöngyölt[i];
        let adóalap = 8500000;
        if (currentGöngyöltBevétel <= 12000000) {
            adóalap = 2500000;
        } else {
            if (currentGöngyöltBevétel <= 18000000) {
                adóalap = 6000000;
            } else {
                if (currentGöngyöltBevétel <= 25000000) {
                    adóalap = 8500000;
                }
            }
        }
        if (currentGöngyöltBevétel > 120000000) {
            adóalap = 0;
        }
        adóalap *= inputIPAKeyPercent / 100
        haviIPAAdatok[i] = adóalap;
        // haviIPAAdatok[i] = (haviBevételek[i] * 1.2 * inputIPAKeyPercent / 100);
    }
}

const haviKiadásokKiszámítása = (): void => {
    for (let i = 0; i < 12; i++) {
        let currentExpense = 0;
        currentExpense += haviSZJA[i]
        currentExpense += haviTB[i]
        if (!inputLegalRelationshipType.toLowerCase().includes("nyugdíj")) {
            currentExpense += haviSZOCHOAdatok[i]
        }
        currentExpense += haviIPAAdatok[i]
        haviÖsszesKöltségAdatok[i] = currentExpense;
        haviNettoAdatok[i] = haviBevételek[i] - currentExpense;
    }
}

const clearBlankMonths = (): void => {
    let startingMonth = getMonthFromDateStringYYYYMMOrHungarianMonthAsText(inputStartDate);
    for (let i = startingMonth - 1; i > 0; i--) {
        haviSZJA[--i] = 0;
        haviSZJAAlapok[--i] = 0;
        haviTB[i] = 0;
        haviSZOCHOAdatok[i] = 0;
        haviIPAAdatok[i] = 0;
        haviÖsszesKöltségAdatok[i] = 0;
        haviNettoAdatok[i++] = 0;
    }
}


export const preCalcAll = (calculatorObj: any, monthlyWagesObjInstance: any): void => {

    console.clear();

    // 2023 logic removed: use current minimálBér and garantáltBérminimum values
    clearArrays();
    inputExpectedIncome = calculatorObj.expectedSalesPerYear
    inputIPAKeyPercent = calculatorObj.IPA
    // Mindig a kiválasztott költséghányadot használjuk, évvizsgálat nélkül
    inputCostRatioPercent = calculatorObj.costRatio;
    inputLegalRelationshipType = calculatorObj.legalRelationShip
    inputStartDate = calculatorObj.dateDisplay;
    inputMinimumWageType = calculatorObj.useMinimumWage;
    inputMinimumWageType = inputMinimumWageType.toUpperCase();
    inputMinimumWageType = inputMinimumWageType.indexOf('MINIMÁLBÉR') !== -1 ? "MINIMUMWAGE" : "GUARANTEEDMINIMUMWAGE";
    let inputCount = document.querySelectorAll("input[type=text]").length;

    if (inputCount === 1) {
        haviÁtlagjövedelmekKiszámítása();
    } else {
        haviEgyediJövedelmekKiszámítása(monthlyWagesObjInstance);
    }

    // console.log();
    haviSZJAlapokKiszámítása();
    haviAdókötelesAdatokKiszámítása();
    haviTBAlapokKiszámítása();
    // Csak nem mellékfoglalkozás esetén futtassuk a _2-es verziót, hogy ne írja felül a TB alapot
    if (inputLegalRelationshipType !== "Mellékfoglalkozású") {
        haviTBAlapokKiszámítása_2();
    }
    //haviSZOCHOAlapokKiszámítása();
    haviKiadásokKiszámítása()
    haviIPAAdatokKiszámítása();

    clearBlankMonths()

    // printDebugData()
}


const clearArrays = (): void => {
    for (let i = 0; i < 12; i++) {
        haviBevételek[i] = 0;
        haviJövedelmek[i] = 0;
        haviJövedelmekGöngyölt[i] = 0;
        haviKöltségarányok[i] = 0;
        haviSZJA[i] = 0;
        haviSZJAAlapok[i] = 0;
        haviTB[i] = 0;
        haviAdóköteles[i] = 0;
        haviAdókötelesGöngyölt[i] = 0;
        haviTBAlap[i] = 0;
        haviSZOCHOAdatok[i] = 0;
        haviSZOCHOAlapAdatok[i] = 0;
        haviIPAAdatok[i] = 0;
        haviÖsszesKöltségAdatok[i] = 0;
        haviNettoAdatok[i] = 0;
    }
}

const MonthlyWages = ({ monthlyWagesObj, setCalculatorObj, calculatorObj, setMonthlyWagesObj, show }: Props) => {
    const [startingMonthIndex, setStartingMonthIndex] = useState(0);


    useEffect(() => {
        calculateMonthlyWages();
        setStartingMonthIndex(displayMonthlyWages(calculatorObj.startingMonth));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [calculatorObj.expectedSalesPerYear, calculatorObj.startingMonth, show])

    const displayMonthlyWages = (startingMonth: string) => {

        let monthIndex = 0;
        if (startingMonth === MONTH.JANUARY) return monthIndex;

        let index = 0;
        months.forEach(month => {
            if (month === startingMonth) monthIndex = index;
            index++;
        });

        return monthIndex;
    }

    const calculateMonthlyWages = async () => {

        let startingMonthIndex = getStartingMonthIndexInMonths(calculatorObj)
        let updatedMonths = months.slice(startingMonthIndex)
        const partialExpectedSales = calculatorObj.expectedSalesPerYear / updatedMonths.length

        setMonthlyWagesObj(prevState => ({
            ...prevState,
            january: updatedMonths.includes(MONTH.JANUARY) ? partialExpectedSales : 0,
            february: updatedMonths.includes(MONTH.FEBRUARY) ? partialExpectedSales : 0,
            march: updatedMonths.includes(MONTH.MARCH) ? partialExpectedSales : 0,
            april: updatedMonths.includes(MONTH.APRIL) ? partialExpectedSales : 0,
            may: updatedMonths.includes(MONTH.MAY) ? partialExpectedSales : 0,
            june: updatedMonths.includes(MONTH.JUNE) ? partialExpectedSales : 0,
            july: updatedMonths.includes(MONTH.JULY) ? partialExpectedSales : 0,
            august: updatedMonths.includes(MONTH.AUGUST) ? partialExpectedSales : 0,
            september: updatedMonths.includes(MONTH.SEPTEMBER) ? partialExpectedSales : 0,
            october: updatedMonths.includes(MONTH.OCTOBER) ? partialExpectedSales : 0,
            november: updatedMonths.includes(MONTH.NOVEMBER) ? partialExpectedSales : 0,
            december: updatedMonths.includes(MONTH.DECEMBER) ? partialExpectedSales : 0
        }))
    }

    const handleChange = async (e: any, name: string) => {

        setMonthlyWagesObj(prevState => ({
            ...prevState,
            [name]: Number((e.target.value).replaceAll(' ', ''))
        }))
    }

    if (!show) return <></>

    return (
        <Grid sx={{ width: '100%' }} alignItems="center" justifyContent="center" container>
            {startingMonthIndex <= 0 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'january'}
                    value={monthlyWagesObj.january}
                    handleInput={handleChange}
                    inputProps={MONTH.JANUARY}
                />
            </Grid>}
            {startingMonthIndex <= 1 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'february'}
                    value={monthlyWagesObj.february}
                    handleInput={handleChange}
                    inputProps={MONTH.FEBRUARY} />
            </Grid>}
            {startingMonthIndex <= 2 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'march'}
                    value={monthlyWagesObj.march}
                    handleInput={handleChange}
                    inputProps={MONTH.MARCH} />
            </Grid>}
            {startingMonthIndex <= 3 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'april'}
                    value={monthlyWagesObj.april}
                    handleInput={handleChange}
                    inputProps={MONTH.APRIL} />
            </Grid>}
            {startingMonthIndex <= 4 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'may'}
                    value={monthlyWagesObj.may}
                    handleInput={handleChange}
                    inputProps={MONTH.MAY} />
            </Grid>}
            {startingMonthIndex <= 5 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'june'}
                    value={monthlyWagesObj.june}
                    handleInput={handleChange}
                    inputProps={MONTH.JUNE}
                    monthNumber={6} />
            </Grid>}
            {startingMonthIndex <= 6 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'july'}
                    value={monthlyWagesObj.july}
                    handleInput={handleChange}
                    inputProps={MONTH.JULY}
                    monthNumber={7} />
            </Grid>}
            {startingMonthIndex <= 7 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'august'}
                    value={monthlyWagesObj.august}
                    handleInput={handleChange}
                    inputProps={MONTH.AUGUST} />
            </Grid>}
            {startingMonthIndex <= 8 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'september'}
                    value={monthlyWagesObj.september}
                    handleInput={handleChange}
                    inputProps={MONTH.SEPTEMBER} />
            </Grid>}
            {startingMonthIndex <= 9 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'october'}
                    value={monthlyWagesObj.october}
                    handleInput={handleChange}
                    inputProps={MONTH.OCTOBER} />
            </Grid>}
            {startingMonthIndex <= 10 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'november'}
                    value={monthlyWagesObj.november}
                    handleInput={handleChange}
                    inputProps={MONTH.NOVEMBER} />
            </Grid>}
            {startingMonthIndex <= 11 && <Grid item xs={12} sm={6} md={4} lg={3} sx={{ padding: '10px' }}>
                <NumberInput name={'december'}
                    value={monthlyWagesObj.december}
                    handleInput={handleChange}
                    inputProps={MONTH.DECEMBER} />
            </Grid>}
        </Grid>)
}

export default MonthlyWages
